var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container wrapper"},[_c('NavBar'),_c('div',{staticClass:"right-panel",attrs:{"id":"right-panel"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }